import React from 'react'
import {Icon} from '@chakra-ui/react'

const PromoIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" data-testid="promo-icon" {...props}>
            <path
                d="M7 4.08337V12.25"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.1"
                d="M4.8125 4.08337V12.25"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.1"
                d="M9.1875 4.08337V12.25"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6668 6.41663V11.0833C11.6668 11.3927 11.5439 11.6895 11.3251 11.9083C11.1063 12.127 10.8096 12.25 10.5002 12.25H3.50016C3.19074 12.25 2.894 12.127 2.6752 11.9083C2.45641 11.6895 2.3335 11.3927 2.3335 11.0833V6.41663"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.37484 4.0833C3.98806 4.0833 3.61713 3.92966 3.34364 3.65617C3.07015 3.38268 2.9165 3.01174 2.9165 2.62497C2.9165 2.2382 3.07015 1.86726 3.34364 1.59377C3.61713 1.32028 3.98806 1.16664 4.37484 1.16664C4.93757 1.15683 5.48902 1.42987 5.95727 1.95015C6.42551 2.47042 6.78883 3.21379 6.99984 4.0833C7.21084 3.21379 7.57416 2.47042 8.04241 1.95015C8.51066 1.42987 9.0621 1.15683 9.62484 1.16664C10.0116 1.16664 10.3825 1.32028 10.656 1.59377C10.9295 1.86726 11.0832 2.2382 11.0832 2.62497C11.0832 3.01174 10.9295 3.38268 10.656 3.65617C10.3825 3.92966 10.0116 4.0833 9.62484 4.0833"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6667 4.08337H2.33333C2.01117 4.08337 1.75 4.34454 1.75 4.66671V5.83337C1.75 6.15554 2.01117 6.41671 2.33333 6.41671H11.6667C11.9888 6.41671 12.25 6.15554 12.25 5.83337V4.66671C12.25 4.34454 11.9888 4.08337 11.6667 4.08337Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default PromoIcon
